/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface DiagnosisTherapist { 
    id: number;
    name: string;
}
export const DiagnosisTherapist_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const DiagnosisTherapist_name_Validators: ValidatorFn[] =
    [  Validators.required, ];


